import {create} from 'zustand'; // 상태 관리 라이브러리
import {createJSONStorage, persist} from 'zustand/middleware'; // 상태 지속성 관리 미들웨어

// 토큰 스토어의 상태와 액션 타입 정의
interface TokenStore {
    accessToken: string | null;                     // 액세스 토큰 저장 (없으면 null)
    setAccessToken: (_accessToken: string) => void; // 토큰 설정 함수
}

// 토큰 스토어 생성
const useTokenStore = create(
    persist<TokenStore>(
        // 스토어 기본 설정
        (set) => ({
            accessToken: null,  // 초기값은 null
            setAccessToken: (_accessToken) => {
                set({accessToken: _accessToken});  // 토큰 업데이트 함수
            },
        }),
        // persist 미들웨어 설정
        {
            name: 'access-token',                             // 스토리지에 저장될 키 이름
            storage: createJSONStorage(() => sessionStorage), // 세션 스토리지 사용
        },
    ),
);

export default useTokenStore;